import { useEffect } from "react"
import { observer } from "mobx-react-lite"
import { SimpleGrid, createStyles, rem } from "@mantine/core"
import { InstructorCard, InstructorListSkeleton } from "entities/instructor"
import { InstructorStore } from "../../app/store"
import { ResultWrapper } from "../../entities/resultWrapper"

// ----------------------------------------------------------------------

const useStyles = createStyles((theme) => ({
  grid: {
    gap: `${rem(64)} ${rem(32)}`,

    [theme.fn.smallerThan("md")]: {
      gap: `${rem(48)} ${rem(24)}`,
    },

    [theme.fn.smallerThan("xs")]: {
      gap: `${rem(64)} ${rem(32)}`,
    },
  },
}))

// ----------------------------------------------------------------------

export const InstructorList = observer(function InstructorList() {
  const { classes } = useStyles()
  const { instructors, isLoading, error, getAll } = InstructorStore

  useEffect(() => {
    void getAll()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <ResultWrapper
      isEmpty={!instructors.length}
      error={error}
      isLoading={isLoading}
      loadingComponent={InstructorListSkeleton}
    >
      <SimpleGrid
        cols={3}
        breakpoints={[
          { maxWidth: "md", cols: 2 },
          { maxWidth: "xs", cols: 1 },
        ]}
        className={classes.grid}
      >
        {instructors.map((instructor) => (
          <InstructorCard key={instructor._id} {...instructor} />
        ))}
      </SimpleGrid>
    </ResultWrapper>
  )
})
